import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import useSWR from 'swr';
import { IgnoredEvent } from '../../../../../../../typings/IgnoredEvent.interface';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { cause_filter_breakdown } from '../../../../utils/rejection-causes';
import Badge from '../../../common/base/Badge';
import Chip from '../../../common/base/Chip';
import Text from '../../../common/base/Text';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { MetadataGrid } from '../../../common/MetadataGrid';
import { Div } from '../../../common/helpers/StyledUtils';
import Alert from '../../../common/base/Alert';
import Divider from '../../../common/base/Divider';
import Loading from '../../../common/base/Loading';
const IgnoredEventSidebarSection: React.FC<{
  ignored_event: IgnoredEvent;
}> = t0 => {
  const $ = _c(40);
  const {
    ignored_event
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  let t1;
  if ($[0] !== ignored_event) {
    t1 = ignored_event && APIMethodKeys.webhooks.get(ignored_event.webhook_id);
    $[0] = ignored_event;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== HookdeckAPI.webhooks || $[3] !== ignored_event?.webhook_id) {
    t2 = () => HookdeckAPI.webhooks.get(ignored_event?.webhook_id as string);
    $[2] = HookdeckAPI.webhooks;
    $[3] = ignored_event?.webhook_id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: webhook,
    error: webhook_error,
    isLoading: webhook_loading
  } = useSWR(t1, t2);
  const transformation_id = ignored_event && typeof ignored_event?.meta === "object" && ignored_event?.meta !== null && "transformation_id" in ignored_event.meta && ignored_event.meta?.transformation_id;
  let t3;
  if ($[5] !== transformation_id) {
    t3 = transformation_id && APIMethodKeys.transformations.get(transformation_id);
    $[5] = transformation_id;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== HookdeckAPI.transformations || $[8] !== transformation_id) {
    t4 = () => HookdeckAPI.transformations.get(transformation_id as string);
    $[7] = HookdeckAPI.transformations;
    $[8] = transformation_id;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    data: transformation,
    error: transformation_error,
    isLoading: transformation_loading
  } = useSWR(t3, t4);
  if (!ignored_event || webhook_loading || transformation_loading) {
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Div flex={{
        grow: true,
        align: "center",
        justify: "center"
      }}><Loading /></Div>;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  let t5;
  if ($[11] !== ignored_event) {
    t5 = cause_filter_breakdown[ignored_event.cause](ignored_event);
    $[11] = ignored_event;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const {
    label,
    text
  } = t5;
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      x: 6,
      t: 6
    };
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      b: 4
    };
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== label || $[16] !== text) {
    t8 = <Alert neutral={true} inline={true} title={label} m={t7}>{text}</Alert>;
    $[15] = label;
    $[16] = text;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Text muted={true} ellipsis={true}>Rejection Cause</Text>;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== label) {
    t10 = <MetadataGrid embedded={true}>{t9}<Badge neutral={true} subtle={true}>{label}</Badge></MetadataGrid>;
    $[19] = label;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Divider />;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Text muted={true} ellipsis={true}>Connection</Text>;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== webhook_error?.response?.status) {
    t13 = webhook_error?.response?.status === 410 && <Text muted={true}>Connection Deleted</Text>;
    $[23] = webhook_error?.response?.status;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== webhook || $[26] !== webhook_error) {
    t14 = !webhook_error && webhook && <Chip outline={true} mono={true} to={webhook && `/connections/${webhook.id}`} label={webhook?.full_name || ""} />;
    $[25] = webhook;
    $[26] = webhook_error;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t13 || $[29] !== t14) {
    t15 = <MetadataGrid embedded={true}>{t12}{t13}{t14}</MetadataGrid>;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Divider />;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== transformation || $[33] !== transformation_error) {
    t17 = transformation && <><MetadataGrid embedded={true}><Text muted={true} ellipsis={true}>Transformation</Text><Div flex={{
          direction: "column",
          gap: 3
        }}>{transformation_error?.response?.status === 410 && <Text muted={true}>Transformation Deleted</Text>}{!transformation_error && transformation && <Chip outline={true} mono={true} to={transformation && `/transformations/${transformation.id}`} label={transformation?.name || ""} />}</Div></MetadataGrid><Divider /></>;
    $[32] = transformation;
    $[33] = transformation_error;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t10 || $[36] !== t15 || $[37] !== t17 || $[38] !== t8) {
    t18 = <Div p={t6}>{t8}{t10}{t11}{t15}{t16}{t17}</Div>;
    $[35] = t10;
    $[36] = t15;
    $[37] = t17;
    $[38] = t8;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
};
export default IgnoredEventSidebarSection;